import { FC, ReactElement } from 'react'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import { IKlantAfleverafspraak } from 'shared/models/IKlantAfleverafspraak'

interface IProps {
  customerDeliveryAgreement: DeliveryLocationModel
}

const CustomerDeliveryAgreementView: FC<IProps> = (
  props: IProps
): ReactElement => {
  /**
   * Assuming this component is being used in a table.
   */
  return (
    <tr className='border'>
      <td>
        <h5>Afleverafspraak</h5>
      </td>
      <td>
        <span className='font-weight-bold'>Referentie:</span>{' '}
        {props?.customerDeliveryAgreement?.deliveryagreementreference ??
          'Geen aar'}
      </td>
      <td>
        <div>
          <span className='font-weight-bold'>Naam:</span>{' '}
          {props?.customerDeliveryAgreement?.name ?? 'Geen AAR naam?'}
        </div>
      </td>
    </tr>
  )
}
export default CustomerDeliveryAgreementView
